import React, { useContext } from "react";
import { FiInfo, FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import * as route from "../../../routes";
import getInitials from "../../../Utils/getInitials";
import { Loader } from "../../../Components/Common";
import { SITE_NOT_FOUND } from "../constants";
import { UserContext } from "../../../Context";

const MobileCardView = ({ sites = [], loading = false, deleteSite }) => {
  const { isAdminOrHO } = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4 md:hidden">
      {loading ? (
        <div className="flex justify-center items-center py-10">
          <Loader />
        </div>
      ) : sites.length > 0 ? (
        sites.map((site) => (
          <div
            key={site.id}
            className="flex items-center justify-between bg-white shadow-md rounded-xl px-4 py-3"
          >
            <div className="flex items-center gap-3 overflow-hidden">
              <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm shrink-0">
                {getInitials(site.name)}
              </div>

              <div className="flex flex-col max-w-[200px] sm:max-w-xs overflow-hidden">
                <div className="text-base font-semibold text-primary truncate">
                  {site.name || "N/A"}
                </div>
                <div className="text-sm text-gray-700 truncate">
                  Client: {site.client?.name || "N/A"}
                </div>
              </div>
            </div>

            <div className="flex gap-3 items-center ml-2">
              <button
                title="View"
                className="text-primary"
                onClick={() =>
                  navigate(route.VIEW_SITE.replace(":siteId", site.id))
                }
              >
                <FiInfo size={20} />
              </button>

              {isAdminOrHO && (
                <button
                  title="Delete"
                  className="text-primary"
                  onClick={() => deleteSite(site.id)}
                >
                  <FiTrash2 size={20} className="text-red-500 cursor-pointer hover:text-red-600"
                    title="Delete File" />
                </button>
              )}
            </div>

          </div>
        ))
      ) : (
        <div className="text-center text-gray-500 font-medium py-10">
          {SITE_NOT_FOUND}
        </div>
      )}
    </div>
  );
};

export default MobileCardView;
